import { Phone } from "lucide-react";
import { scrollToContact } from "./Hero";

export const TopBar = () => (
  <header
    data-testid="top-bar"
    className="fixed top-0 left-0 right-0 z-50 bg-white/85 backdrop-blur-md border-b border-[rgba(11,27,61,0.1)]"
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-10 h-14 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <img
          src="/dpm-logo-transparent.png"
          alt="DPM"
          className="h-9 w-9 object-contain"
          draggable="false"
        />
        <span className="hidden sm:block w-px h-5 bg-[rgba(11,27,61,0.15)]" />
        <span
          data-testid="ma-opportunity-tag"
          className="flex items-center gap-2 text-[10px] sm:text-[11px] font-semibold tracking-[0.25em] uppercase text-[#0B1B3D]"
        >
          <span className="w-1.5 h-1.5 bg-[#C5A059]" />
          M&amp;A Opportunity
        </span>
      </div>
      <div className="flex items-center gap-6">
        <a
          href="tel:3214741855"
          data-testid="topbar-phone"
          className="hidden md:flex items-center gap-2 text-sm font-semibold text-[#0B1B3D] hover:text-[#C5A059] transition-colors duration-300"
        >
          <Phone size={14} strokeWidth={2} className="text-[#C5A059]" />
          321-474-1855
        </a>
        <button
          data-testid="topbar-contact-button"
          onClick={scrollToContact}
          className="font-heading text-[11px] font-bold tracking-[0.18em] uppercase bg-[#0B1B3D] text-white px-5 py-2.5 border border-[#0B1B3D] hover:bg-[#C5A059] hover:border-[#C5A059] hover:text-[#0B1B3D] transition-colors duration-300"
        >
          Contact Us
        </button>
      </div>
    </div>
  </header>
);
